import React from 'react';
import PropTypes from 'prop-types';

import './CallForSpeakers.scss';
import { CallForSpeakersConsumer } from '../../contexts/CallForSpeakersContext';
import CFSForm from './components/CFSForm';
import CFSSummary from './components/CFSSummary';

export class CallForSpeakers extends React.PureComponent {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    this.props.resetForm();
  }

  onSubmit = event => {
    event.preventDefault();
    if (this.isValidForm()) {
      this.props.submitCFSForm();
    }
  };

  closeAlert = () => {
    this.props.updateFormStatus('formFailed', false);
  };

  isValidValue = fieldName => {
    const field = this.props.fields[fieldName];
    let value;

    if (fieldName === 'stream') {
      value = field.touched && field.value.length === 0 ? value : true;
    } else {
      value = fieldName === 'disclaimer' ? field.value : field.value.trim();
      return field.touched && field.value.length === 0 ? value : true;
    }

    return value;
  };

  isValidSpeakerValue = (id, fieldName) => {
    const { fields } = this.props;
    const { speakers } = fields;
    const matchSpeaker = speakers.find(s => s.id === id);
    const field = matchSpeaker[fieldName];
    const value = field.value.trim();
    return field.touched ? value : true;
  };

  isValidForm = () =>
    !Object.keys(this.props.fields).find(key => {
      if (key === 'stream') {
        return false;
      }

      if (key === 'track') {
        if (this.props.fields.track.value === 'Talk') {
          if (!(this.props.fields.stream.value.length > 0)) {
            return true;
          }
          return false;
        }

        return this.props.fields[key].value.length === 0;
      }

      if (key === 'speakers') {
        return this.props.fields.speakers.find(speaker =>
          Object.keys(speaker).find(speakerKey => {
            if (speakerKey === 'id') {
              return false;
            }
            return speaker[speakerKey].value.length === 0;
          })
        );
      }

      if (key === 'disclaimer') {
        return !this.props.fields[key].value;
      }

      return this.props.fields[key].value.length === 0;
    });

  updateValue = event => {
    const { name } = event.target;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

    this.props.updateCFSFieldValue(name, value);
  };

  updateCheckboxValue = event => {
    const { name, value, checked } = event.target;
    this.props.updateCFSMultipleFieldValue(name, value, checked);
  };

  updateSpeaker = (id, event, error = '') => {
    let name = '';
    let value = '';
    if (event.target) {
      name = event.target.name;
      value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    } else {
      name = 'photo';
      value = event;
    }
    this.props.updateSpeaker(id, name, value, error);
  };

  onDrop = (speakerId, picture) => {
    if (picture.length > 0) {
      if (picture[0].size > 1048576) {
        this.updateSpeaker(speakerId, '', 'Image size is too big.');
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(picture[0]);
      reader.onload = event => {
        const dataUrl = event.target.result;

        const image = new Image();
        image.src = dataUrl;
        image.onload = () => {
          if (image.width === image.height) {
            this.resizeImage(image, speakerId);
          } else {
            this.updateSpeaker(speakerId, '', 'Image dimensions are not equal.');
          }
        };
        image.onerror = () => {
          this.updateSpeaker(speakerId, '', 'File is not an image.');
        };
      };
    } else {
      this.updateSpeaker(speakerId, '', '');
    }
  };

  resizeImage = (image, speakerId) => {
    const canvas = document.createElement('canvas');
    canvas.width = 200;
    canvas.height = 200;
    const canvasContext = canvas.getContext('2d');
    canvasContext.drawImage(image, 0, 0, 200, 200);
    const imgSrc = canvas.toDataURL('image/jpeg');
    this.updateSpeaker(speakerId, imgSrc, '');
  };

  render() {
    const { addSpeaker, removeSpeaker } = this.props;
    const title = this.props.formSubmitted ? (
      <div className="page-header text-center cfs-form">
        <h1 className="title">Call for Speakers submitted successfully</h1>
      </div>
    ) : (
      <div className="page-header text-center cfs-form">
        <h1 className="title">Call for Speakers</h1>
      </div>
    );

    const fieldsRequired = !this.props.formSubmitted ? (
      <h3 className="text-center fields-req cfs-form">
        <strong>
          <p className="text-danger">All fields are required.</p>
        </strong>
      </h3>
    ) : null;

    const content = this.props.formSubmitted ? (
      <CFSSummary fields={this.props.fields} />
    ) : (
      <CFSForm
        addSpeaker={addSpeaker}
        closeAlert={this.closeAlert}
        fields={this.props.fields}
        formFailed={this.props.formFailed}
        formSubmitInProgress={this.props.formSubmitInProgress}
        isValidForm={this.isValidForm}
        isValidSpeakerValue={this.isValidSpeakerValue}
        isValidValue={this.isValidValue}
        onDrop={this.onDrop}
        onPictureDelete={this.onPictureDelete}
        onSubmit={this.onSubmit}
        removeSpeaker={removeSpeaker}
        updateCheckboxValue={this.updateCheckboxValue}
        updateSpeaker={this.updateSpeaker}
        updateValue={this.updateValue}
      />
    );

    return (
      <section className="section" id="cfs">
        <div className="container call-for-speakers">
          {title}
          {fieldsRequired}
          {content}
        </div>
      </section>
    );
  }
}

CallForSpeakers.propTypes = {
  addSpeaker: PropTypes.func.isRequired,
  fields: PropTypes.objectOf(PropTypes.any).isRequired,
  formFailed: PropTypes.bool.isRequired,
  formSubmitInProgress: PropTypes.bool.isRequired,
  formSubmitted: PropTypes.bool.isRequired,
  removeSpeaker: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  submitCFSForm: PropTypes.func.isRequired,
  updateCFSFieldValue: PropTypes.func.isRequired,
  updateCFSMultipleFieldValue: PropTypes.func.isRequired,
  updateFormStatus: PropTypes.func.isRequired,
  updateSpeaker: PropTypes.func.isRequired
};

const CallForSpeakersContainer = props => (
  <CallForSpeakersConsumer>
    {({
      fields,
      formFailed,
      formSubmitted,
      formSubmitInProgress,
      updateCFSMultipleFieldValue,
      updateCFSFieldValue,
      updateSpeaker,
      resetForm,
      addSpeaker,
      removeSpeaker,
      submitCFSForm,
      updateFormStatus
    }) => (
      <CallForSpeakers
        addSpeaker={addSpeaker}
        fields={fields}
        formFailed={formFailed}
        formSubmitInProgress={formSubmitInProgress}
        formSubmitted={formSubmitted}
        removeSpeaker={removeSpeaker}
        resetForm={resetForm}
        submitCFSForm={submitCFSForm}
        updateCFSFieldValue={updateCFSFieldValue}
        updateCFSMultipleFieldValue={updateCFSMultipleFieldValue}
        updateFormStatus={updateFormStatus}
        updateSpeaker={updateSpeaker}
        {...props}
      />
    )}
  </CallForSpeakersConsumer>
);

export default CallForSpeakersContainer;
